import { useEffect } from 'react';

/**
 * Aktiviert die visuelle Finance-Designschicht auch fuer Portal-Inhalte.
 * Modale werden an document.body gerendert und liegen deshalb ausserhalb des
 * Seiten-Wrappers. Die Body-Klasse haelt Seite und Overlay trotzdem konsistent.
 */
export const useFinanceDesignContext = () => {
  useEffect(() => {
    document.body.classList.add('finance-design-active');

    return () => {
      document.body.classList.remove('finance-design-active');
    };
  }, []);
};

export default useFinanceDesignContext;
